import { render, staticRenderFns } from "./edition-feature-tree.vue?vue&type=template&id=0b48dd10&scoped=true&"
import script from "./edition-feature-tree.vue?vue&type=script&lang=js&"
export * from "./edition-feature-tree.vue?vue&type=script&lang=js&"
import style0 from "./edition-feature-tree.vue?vue&type=style&index=0&id=0b48dd10&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b48dd10",
  null
  
)

export default component.exports